// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 2177) return "static/chunks/2177-af25450bf1e06412.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"5443":"ad7f724d","6350":"72a30a16","7847":"e78312c5"}[chunkId] || chunkId) + "." + {"2442":"9c4a17fe267ff7e4","5443":"770eba45a39f0de5","6350":"c145f9e99753ade9","7847":"0ec2480823920632","7856":"9d24a4020a407814","7981":"ceec7efef3d0d3d9","9947":"2cd38e695fb5250d"}[chunkId] + ".js";
};